<template>
  <div class="asset-item bg-bi-bg">
    <span class="title" style="color: #fff;">{{ safetypeName }}</span>
    <p>{{ isopen ? '$ ' + safeconversion : '****' }}</p>
    <van-row class="asset-data-info">
      <van-col :span="12">
        <span style="color: #fff !important;">{{ $t('assets.usenum') }}</span>
        <p>{{ isopen ? safeuseNum : '****' }}</p>
      </van-col>
      <van-col :span="12" v-if="safefreezeNum">
        <span style="color: #fff !important;">{{ $t('assets.freeze') }}</span>
        <p>{{ isopen ? safefreezeNum : '****' }}</p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'AssetItem',
  props: [
    'typeName',
    'typeId',
    'link',
    'useNum',
    'freezeNum',
    'conversion',
    'isopen'
  ],
  computed: {
    safetypeId () {
      return this.typeId || 0
    },
    safetypeName () {
      return this.typeName || ''
    },
    safelink () {
      return this.link || ''
    },
    safeuseNum () {
      return this.useNum || ''
    },
    safefreezeNum () {
      return this.freezeNum || ''
    },
    safeconversion () {
      return this.conversion || ''
    },
    safeIsOpen () {
      return this.isopen || true
    }
  },
  watch: {
    isopen: {
      handler (newVal, oldVal) {
        console.log(newVal + ',' + oldVal)
      },
      deep: true
    }
  },
  methods: {
    toPage () {
      this.$router.push(
        {
          name: 'trade-account',
          query: {
            id: this.safelink,
            name: this.safetypeName,
            type: this.safetypeId,
            usd: this.safeuseNum,
            conversion: this.safeconversion
          }
        },
        () => {}
      )
    }
  }
}
</script>

<style>
.bg-bi-bg {
  background-image: url(../../../assets/img_7.png);
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 20px;
  line-height: 1.5;
}
</style>
